/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'embedded-confluence-common.src.content.empty-state-description': 'Vi tittade överallt, men den finns bara inte. Den kan ha raderats. Såvida webbadressen inte innehåller något stavfel 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
  'embedded.confluence.already-logged-in-paragraph': 'Är du redan inloggad? Uppdatera sidan.',
  'embedded.confluence.footer.hover.text': 'Visa i Confluence',
  'embedded.confluence.footer.prefix': 'Drivs av',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Logga in på Confluence',
  'embedded.confluence.login-page.login-button': 'Logga in på Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
  'embedded.confluence.login-page.login-text': 'Du måste vara inloggad för att visa den här sidan',
  'embedded.confluence.login-page.refresh-page-banner': 'Den här sidan bör uppdateras automatiskt efter inloggningen. Annars kan du klicka här för att uppdatera den',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
  'embedded.confluence.need-to-log-in-paragraph': 'Du måste vara inloggad för att visa den här sidan',
  'embedded.confluence.still-having-trouble-paragraph': 'Har du fortfarande problem? Se till att cookies för tredje parter är aktiverade, eller {link}',
  'embedded.confluence.troubleshooting-link-text': 'kolla in den här felsökningsguiden.',
  'embedded.confluence.troubleshooting-link.aria-label': 'länk till felsökningsguide'
};